import * as pdfjs from 'pdfjs-dist';

import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SnAbilityService } from '@lib/ability';
import { SnMedia } from '@lib/api/entities';

@Component({
  selector: 'sn-location-media-list-item',
  templateUrl: './location-media-list-item.component.html',
  styleUrls: ['./location-media-list-item.component.scss'],
})
export class LocationMediaListItemComponent implements OnInit {
  get isImage(): boolean {
    const file = this.title;
    return file?.includes('.jpeg') || file?.includes('.jpg') || file?.includes('.png');
  }

  get isPdf(): boolean {
    return this.title?.includes('.pdf') || this.item.description?.includes('.pdf');
  }

  get showIcon(): boolean {
    return !this.isImage && !this.isPdf;
  }

  @Input()
  public item: SnMedia;

  @Output()
  public readonly fileDeleted = new EventEmitter<SnMedia>();
  public readonly canDelete: boolean;
  public isLoading: boolean = false;
  public title: string;

  private _canvas: HTMLCanvasElement;
  private _context: any;

  constructor(ability: SnAbilityService, private readonly _elementRef: ElementRef) {
    this.canDelete = ability.can({ subject: 'maps/locationmedia', action: 'delete' });
  }

  public ngOnInit(): void {
    this._getTitle();
    if (this.isPdf) {
      this._getDocument();
    }
  }

  public download(): void {
    const downloadLink = document.createElement('a');
    downloadLink.setAttribute('download', this.title);
    downloadLink.setAttribute('href', this.item.file);
    window.open(downloadLink.toString(), '_blank');
  }

  public deleteItem(): void {
    this.fileDeleted.emit(this.item);
  }

  private _getDocument(): void {
    this.isLoading = true;
    pdfjs.GlobalWorkerOptions.workerSrc = 'pdf.worker.js';
    const loadingTask = pdfjs.getDocument(this.item.file);
    loadingTask.promise.then((file) => {
      file.getPage(1).then((page) => {
        if (page) {
          page.cleanup();
        }
        const scale = 1;
        const viewport = page.getViewport({ scale });

        this._canvas = this._elementRef.nativeElement.querySelector('#canvasEl');
        this._context = this._canvas.getContext('2d');
        this._canvas.height = viewport.height;
        this._canvas.width = viewport.width;

        const renderContext = {
          canvasContext: this._context,
          viewport,
        };
        page.render(renderContext);
        page.cleanupAfterRender = true;
        this.isLoading = false;
      });
    });
  }

  private _getTitle(): void {
    const url: string = this.item.file;
    const fields = url.split('?')[0].split('/');
    this.title = fields[7];
  }
}
